var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12087",
    "data-name": "Group 12087",
    transform: "translate(-6438 -21593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1171284617",
    "data-name": "Group 1171284617",
    transform: "translate(6438.166 21593.166)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-0.166 -0.166)",
    fill: "#4165f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(6441.5 21506.934)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 2.001,
    cy: 2.001,
    r: 2.001,
    transform: "translate(4.499 94.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49603",
    "data-name": "Path 49603",
    d: "M12.8,95.515c-1.538-1.859-3.867-3.649-6.3-3.649S1.737,93.657.2,95.515a.87.87,0,0,0,0,1.109A13.028,13.028,0,0,0,2.479,98.78a6.173,6.173,0,0,0,8.043,0A13.028,13.028,0,0,0,12.8,96.623.87.87,0,0,0,12.8,95.515ZM6.5,93.267a2.8,2.8,0,1,1-2.8,2.8A2.805,2.805,0,0,1,6.5,93.267Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewFile);
export default __webpack_public_path__ + "static/media/previewFile.478c1eefc60a1c66f536f04be3c82f2a.svg";
export { ForwardRef as ReactComponent };